export default __webpack_public_path__ + "static/media/groupUser.dfec8a00.svg";